/*
 * Application Insights JavaScript SDK - Common, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { __extendsFn } from "@microsoft/applicationinsights-shims";
import { PageViewData } from '../Interfaces/Contracts/Generated/PageViewData';
import { DataSanitizer } from './Common/DataSanitizer';
import { FieldType } from '../Enums';
import { msToTimeSpan } from '../HelperFuncs';
import { strNotSpecified } from '../Constants';
var PageView = /** @class */ (function (_super) {
    __extendsFn(PageView, _super);
    /**
     * Constructs a new instance of the PageEventTelemetry object
     */
    function PageView(logger, name, url, durationMs, properties, measurements, id) {
        var _this = _super.call(this) || this;
        _this.aiDataContract = {
            ver: FieldType.Required,
            name: FieldType.Default,
            url: FieldType.Default,
            duration: FieldType.Default,
            properties: FieldType.Default,
            measurements: FieldType.Default,
            id: FieldType.Default
        };
        _this.id = DataSanitizer.sanitizeId(logger, id);
        _this.url = DataSanitizer.sanitizeUrl(logger, url);
        _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
        if (!isNaN(durationMs)) {
            _this.duration = msToTimeSpan(durationMs);
        }
        _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
        _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
        return _this;
    }
    PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
    PageView.dataType = "PageviewData";
    return PageView;
}(PageViewData));
export { PageView };
//# sourceMappingURL=PageView.js.map